export enum OrderStatus {
  Inprogress = 1,
  Completed,
  Unacceptable,
  Draft,
  Signed,
  UnSigned,
}
